/**
 * Labstep
 *
 * @module components/Layout/Menu/TopBar/Profile/ViewComponent
 * @desc Profile (opening in right side bar)
 */

import { ProfilePicture } from 'labstep-web/components/Profile/Picture';
import { withAuthenticatedUserEntity } from 'labstep-web/containers/AuthenticatedUser';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { Size } from 'labstep-web/core/Initials/types';
import { MediaQueryMobile as Mobile } from 'labstep-web/core/MediaQuery/Mobile';
import type React from 'react';
import type { LayoutMenuTopBarProfileViewComponentProps } from './types';

export const LayoutMenuTopBarProfileViewComponent: React.FC<
  LayoutMenuTopBarProfileViewComponentProps
> = ({ authenticatedUserEntity }) => (
  <Mobile>
    {({ match }): React.ReactElement =>
      match ? (
        <ActionComponent
          type="icon"
          icon="ellipsis vertical"
          elementProps={{
            color: 'blue',
          }}
        />
      ) : (
        <ProfilePicture
          linkable={false}
          entity={authenticatedUserEntity}
          size={Size.mini}
        />
      )
    }
  </Mobile>
);

export default withAuthenticatedUserEntity(
  LayoutMenuTopBarProfileViewComponent,
);
